// @flow

/**
 * @author Junaid Atari <mj.atari@gmail.com>
 * @link http://junaidatari.com Author Website
 * @since 2020-09-01
 */

export const MAP_SIZE_MIN: number = 1;
export const MAP_SIZE_MAX: number = 12;
export const MAP_SIZE_DEFAULT: number = 4;

